/**
 * Experimental native sharing web API
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/canShare
 *
 * As of 2020/08/07, mobile Chrome supports functionality of ShareCapableNavigator (share, canShare),
 * whereas Safari (iOS and desktop) only conforms to BasicShareCapableNavigator (share)
 */

interface SharePayload {
  title: string
  text: string
  url: string
}

interface BasicShareCapableNavigator extends Navigator {
  share: (options: SharePayload) => Promise<void>
}

interface ShareCapableNavigator extends BasicShareCapableNavigator {
  share: (options: SharePayload) => Promise<void>
  canShare: (options: SharePayload) => boolean
}

export function isBasicShareCapable(nav: Navigator): nav is BasicShareCapableNavigator {
  return typeof (nav as BasicShareCapableNavigator).share === 'function'
}

function isShareCapable(nav: BasicShareCapableNavigator): nav is ShareCapableNavigator {
  return typeof (nav as ShareCapableNavigator).canShare === 'function'
}

/**
 * Checks canShare() if available, otherwise always returns true
 * @param nav
 * @param options
 */
export function canNavigatorShare(nav: BasicShareCapableNavigator, options: SharePayload): boolean {
  if (isShareCapable(nav)) {
    return nav.canShare(options)
  }

  return true
}
